module.exports = __webpack_public_path__ + "485e9e5234b36a12d673e0dd1d269566.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/quanta_services_2023_chart.png
// module id = 1729
// module chunks = 0